<div class="renovate-contract-pymes-form">
  <section>
    <h2 class="renovate-contract-pymes-form__title">
      {{ 'RENOVATE_COTRACT.RISK_CAMPAIGN' | i18nextEager | uppercase }}
    </h2>
    <div class="renovate-contract-pymes-form__container">
      <div class="renovate-contract-pymes-form__container-field">
        <span class="renovate-contract-pymes-form__title-field">
          {{ 'RENOVATE_COTRACT.CUPS' | i18nextEager | uppercase }}
        </span>
        <span class="renovate-contract-pymes-form__label">{{ dataContract.campaign.cups }}</span>
      </div>
      <div class="renovate-contract-pymes-form__container-field">
        <span class="renovate-contract-pymes-form__title-field">
          {{ 'RENOVATE_COTRACT.CIF' | i18nextEager | uppercase }}
        </span>
        <span class="renovate-contract-pymes-form__label">{{ dataContract.campaign.cif }}</span>
      </div>
      <div *ngIf="!isUserSpanish" class="renovate-contract-pymes-form__container-field">
        <span class="renovate-contract-pymes-form__title-field">
          {{ 'NEW_CONTRACTS.POTENCY' | i18nextEager | uppercase }}
        </span>
        <span class="renovate-contract-pymes-form__label">{{ dataContract?.campaign?.potencyContractedPeriod[0] }}</span>
      </div>
      <div class="renovate-contract-pymes-form__container-field">
        <span class="renovate-contract-pymes-form__title-field">
          {{ 'RENOVATE_COTRACT.ANNUAL_CONSUMPTION' | i18nextEager | uppercase }}
        </span>
        <span class="renovate-contract-pymes-form__label">{{ dataContract.campaign.estimateConsuption | number }} kWh</span>
      </div>
      <div *ngIf="isUserSpanish" class="renovate-contract-pymes-form__consumption-power">
        <div class="renovate-contract-pymes-form__consumption-power-box">
          <h4 class="renovate-contract-pymes-form__consumption-power-title">
            {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.CONSUMPTION' | i18nextEager }} (kWh)
          </h4>
          <div class="renovate-contract-pymes-form__consumption-power-content">
            <div *ngFor="let consumption of [0, 1, 2, 3, 4, 5]"
              class="renovate-contract-pymes-form__consumption-power-period">
              <p class="renovate-contract-pymes-form__consumption-power-period-title">
                {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.P' | i18nextEager }}{{ consumption + 1 }}
              </p>
              <p class="renovate-contract-pymes-form__consumption-power-period-value">
                {{
                dataContract?.campaign?.consumptionEstimatedPeriod?.length > 0 &&
                (dataContract?.campaign?.consumptionEstimatedPeriod)[consumption] !== 0
                ? ((dataContract?.campaign?.consumptionEstimatedPeriod)[consumption] | number)
                : ''
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="renovate-contract-pymes-form__consumption-power-box">
          <h4 class="renovate-contract-pymes-form__consumption-power-title">
            {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.POWER' | i18nextEager }} (kw)
          </h4>
          <div class="renovate-contract-pymes-form__consumption-power-content">
            <div *ngFor="let power of [0, 1, 2, 3, 4, 5]"
              class="renovate-contract-pymes-form__consumption-power-period">
              <p class="renovate-contract-pymes-form__consumption-power-period-title">
                {{ 'NEW_CONTRACTS.CONSUMPTION-POWER-INFO.P' | i18nextEager }}{{ power + 1 }}
              </p>
              <p class="renovate-contract-pymes-form__consumption-power-period-value">
                {{
                dataContract?.campaign?.potencyContractedPeriod?.length > 0 &&
                (dataContract?.campaign?.potencyContractedPeriod)[power] !== 0
                ? ((dataContract?.campaign?.potencyContractedPeriod)[power] | number)
                : ''
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="renovate-contract-pymes-form__container-field">
        <span class="renovate-contract-pymes-form__title-field renovate-contract-pymes-form__title-field--button">
          {{ 'RENOVATE_COTRACT.CREDIT_ANALYSIS' | i18nextEager | uppercase }}
        </span>
        <div class="renovate-contract-pymes-form__container-label">
          <ng-container *ngIf="approved && callQuery">
            <img src="/assets/icons/approved.svg" alt="{{ 'RENOVATE_COTRACT.APPROVED' | i18nextEager }}" />
            <span class="renovate-contract-pymes-form__label">{{ 'RENOVATE_COTRACT.APPROVED' | i18nextEager }}</span>
          </ng-container>
          <ng-container *ngIf="!approved && callQuery">
            <img src="/assets/icons/rejected.svg" alt="{{ 'RENOVATE_COTRACT.REJECTED' | i18nextEager }}" />
            <span class="renovate-contract-pymes-form__label">{{ 'RENOVATE_COTRACT.REJECTED' | i18nextEager }}</span>
          </ng-container>
          <button class="renovate-contract-pymes-form__button" (click)="handleQuery()" [disabled]="callQuery">
            {{ 'RENOVATE_COTRACT.QUERY' | i18nextEager }}
          </button>
        </div>
      </div>
    </div>
    <form [formGroup]="renovateForm">
      <div class="renovate-contract-pymes-form__container">
        <mat-form-field *ngIf="isUserSpanish" appearance="outline">
          <mat-label>{{ 'RENOVATE_COTRACT.ACCESS_FEE' | i18nextEager }}</mat-label>
          <input class="width100" matInput formControlName="fee" maxlength="100" />
        </mat-form-field>
        <app-custom-select class="width100" [label]="'RENOVATE_COTRACT.CAMPAIGN'" [controlName]="'campaign'"
          [values]="campaignList" [required]="true" [defaultValue]="renovateForm.get('campaign').value"
          [disabled]="renovateForm.get('campaign').disabled"></app-custom-select>
      </div>
      <div *ngIf="!isUserSpanish" class="renovate-contract-pymes-form__container">
        <mat-radio-group aria-label="" formControlName="payment">
          <mat-radio-button value="0" [disabled]="renovateForm.get('payment').disabled">
            {{ 'NEW_CONTRACTS.DOMICILIATION' | i18nextEager }}
          </mat-radio-button>
          <mat-radio-button value="1" [disabled]="renovateForm.get('payment').disabled">
            {{ 'NEW_CONTRACTS.MULTIBANK' | i18nextEager }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div *ngIf="!isUserSpanish && showBankAccountFields"
        class="renovate-contract-pymes-form__account renovate-contract-pymes-form__hide-account renovate-contract-pymes-form__account--margin-bottom"
      >
        <div id="iban">****</div>
        <div id="entity">****</div>
        <div id="office">****</div>
        <div id="account">***********</div>
        <div id="dc">{{ dataContract.contract.renovateDc }}</div>
      </div>
      <div *ngIf="!isUserSpanish && showBankAccountFields" class="renovate-contract-pymes-form__account renovate-contract-pymes-form__account-pt">
        <div >
          <mat-form-field appearance="outline" id="iban">
            <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
            <input matInput uppercase id="ibanInput" formControlName="iban" maxlength="4" (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput')" />
          </mat-form-field>
          <mat-form-field appearance="outline" id="entity">
            <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
            <input matInput numeric id="entityInput" formControlName="entity" maxlength="4" (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput')" />
          </mat-form-field>
          <mat-form-field appearance="outline" id="office">
            <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
            <input matInput numeric id="officeInput" formControlName="office" maxlength="4" (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'entityInput', 'officeInput', 'accountInput')" />
          </mat-form-field>
          <mat-form-field appearance="outline" id="account">
            <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
            <input matInput numeric id="accountInput" formControlName="account" [maxlength]="isUserSpanish ? 10 : 11" (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'officeInput', 'accountInput', 'dcInput')" />
          </mat-form-field>
          <mat-form-field appearance="outline" id="dc">
            <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
            <input matInput numeric id="dcInput" formControlName="dc" maxlength="2" (paste)="onPasteIBAN($event)"
              (keyup)="bankAccountKeyUp($event, 'accountInput', 'dcInput', null)"
            />
          </mat-form-field>
        </div>
        <div class="renovate-contract-pymes-form__account-error" *ngIf="renovateForm?.hasError('invalid_IBAN')">
          <mat-error>
            {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
          </mat-error>
        </div>
      </div>
      <div *ngIf="renovateForm.get('campaignBase').value"
        class="renovate-contract-pymes-form__select-calculate-commission">
        <!-- <div *ngIf="fixPrice" class="renovate-contract-pymes-form__section renovate-contract-pymes-form__section--red">
          <div class="renovate-contract-pymes-form__header">
            <h2>{{ 'NEW_CONTRACTS.CALCULATE_COMMISSION' | i18nextEager }}</h2>
          </div>
          <div class="renovate-contract-pymes-form__container-radio">
            <mat-radio-group aria-labelledby="" formControlName="marginIndicator" ngDefaultControl>
              <mat-radio-button value="1">
                <span>{{ 'NEW_CONTRACTS.ENTER_MARGIN' | i18nextEager }}</span>
              </mat-radio-button>
              <mat-radio-button *ngIf="isUserSpanish" value="2">
                <span>{{ 'NEW_CONTRACTS.MARGIN_PRICE' | i18nextEager }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div> -->
        <app-monopoint-calculate-margin
          *ngIf="renovateForm.get('marginIndicator').value === '1'"
          [selectedCampaign]="selectedCampaign"
          [campaignDetail]="campaignDetail"
          [greaterEqual100]="greaterEqual100"
          [geographicZone]="dataContract.campaign.geographicZone"
          [fee]="renovateForm.get('fee').value"
          [enterMarginsDraft]="enterMarginsDraft"
          (enterMargins)="getEnterMargins($event)"
        ></app-monopoint-calculate-margin>
        <ng-container *ngIf="renovateForm.get('marginIndicator').value === '2'">
          <div class="renovate-contract-pymes-form__section">
            <div class="renovate-contract-pymes-form__header">
              <h2>{{ 'NEW_CONTRACTS.CALCULATE_MARGIN' | i18nextEager }}</h2>
            </div>
            <div class="renovate-contract-pymes-form__title-terms">
              <div class="renovate-contract-pymes-form__title-terms--bold">
                {{ 'NEW_CONTRACTS.PRICE_TE' | i18nextEager }}
              </div>
            </div>
            <div class="renovate-contract-pymes-form__space--30"></div>
            <div class="renovate-contract-pymes-form__grid-col--8 renovate-contract-pymes-form__gap--20">
              <div class="renovate-contract-pymes-form__col-span--2">
                <app-custom-select class="width100" [label]="'NEW_CONTRACTS.UNITS_TE'" [controlName]="'unitsTE'"
                  [values]="unitsTE" [required]="true" [defaultValue]="renovateForm.get('unitsTE').value">
                </app-custom-select>
              </div>
              <div formGroupName="calculateMargins" class="renovate-contract-pymes-form__col-span--6">
                <div class="renovate-contract-pymes-form__grid-col--6 renovate-contract-pymes-form__gap--30"
                  formGroupName="marginTE">
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTE.p1').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTE.p1').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p1').dirty
                        )
                    }">
                    <mat-label>P1</mat-label>
                    <input matInput formControlName="p1" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTE.p1')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTE.p1').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTE.p1').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p1').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTE.p2').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTE.p2').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p2').dirty
                        )
                    }">
                    <mat-label>P2</mat-label>
                    <input matInput formControlName="p2" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTE.p2')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTE.p2').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTE.p2').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p2').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTE.p3').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTE.p3').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p3').dirty
                        )
                    }">
                    <mat-label>P3</mat-label>
                    <input matInput formControlName="p3" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTE.p3')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTE.p3').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTE.p3').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p3').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTE.p4').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTE.p4').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p4').dirty
                        )
                    }">
                    <mat-label>P4</mat-label>
                    <input matInput formControlName="p4" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTE.p4')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTE.p4').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTE.p4').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p4').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTE.p5').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTE.p5').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p5').dirty
                        )
                    }">
                    <mat-label>P5</mat-label>
                    <input matInput formControlName="p5" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTE.p5')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTE.p5').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTE.p5').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p5').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTE.p6').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTE.p6').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p6').dirty
                        )
                    }">
                    <mat-label>P6</mat-label>
                    <input matInput formControlName="p6" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTE.p6')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTE.p6').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTE.p6').touched ||
                          renovateForm?.get('calculateMargins.marginTE.p6').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="renovate-contract-pymes-form__title-terms">
              <div class="renovate-contract-pymes-form__title-terms--bold">
                {{ 'NEW_CONTRACTS.PRICE_TP' | i18nextEager }}
              </div>
            </div>
            <div class="renovate-contract-pymes-form__space--30"></div>
            <div class="renovate-contract-pymes-form__grid-col--8 renovate-contract-pymes-form__gap--20">
              <div class="renovate-contract-pymes-form__col-span--2">
                <app-custom-select class="width100" [label]="'NEW_CONTRACTS.UNITS_TP'" [controlName]="'unitsTP'"
                  [values]="unitsTP" [required]="true" [defaultValue]="renovateForm.get('unitsTP').value">
                </app-custom-select>
              </div>
              <div formGroupName="calculateMargins" class="renovate-contract-pymes-form__col-span--6">
                <div class="renovate-contract-pymes-form__grid-col--6 renovate-contract-pymes-form__gap--30"
                  formGroupName="marginTP">
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTP.p1').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTP.p1').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p1').dirty
                        )
                    }">
                    <mat-label>P1</mat-label>
                    <input matInput formControlName="p1" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTP.p1')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTP.p1').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTP.p1').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p1').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTP.p2').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTP.p2').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p2').dirty
                        )
                    }">
                    <mat-label>P2</mat-label>
                    <input matInput formControlName="p2" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTP.p2')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTP.p2').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTP.p2').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p2').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTP.p3').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTP.p3').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p3').dirty
                        )
                    }">
                    <mat-label>P3</mat-label>
                    <input matInput formControlName="p3" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTP.p3')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTP.p3').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTP.p3').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p3').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTP.p4').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTP.p4').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p4').dirty
                        )
                    }">
                    <mat-label>P4</mat-label>
                    <input matInput formControlName="p4" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTP.p4')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTP.p4').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTP.p4').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p4').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTP.p5').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTP.p5').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p5').dirty
                        )
                    }">
                    <mat-label>P5</mat-label>
                    <input matInput formControlName="p5" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTP.p5')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTP.p5').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTP.p5').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p5').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" [ngClass]="{
                      'renovate-contract-pymes-form__fix-label':
                        renovateForm?.get('calculateMargins.marginTP.p6').invalid &&
                        !(
                          renovateForm?.get('calculateMargins.marginTP.p6').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p6').dirty
                        )
                    }">
                    <mat-label>P6</mat-label>
                    <input matInput formControlName="p6" numberCustom [regex]="regexSixDecimal"
                      [formControl]="renovateForm.get('calculateMargins.marginTP.p6')" />
                    <mat-error *ngIf="
                        renovateForm?.get('calculateMargins.marginTP.p6').errors?.required &&
                        (renovateForm?.get('calculateMargins.marginTP.p6').touched ||
                          renovateForm?.get('calculateMargins.marginTP.p6').dirty)
                      ">
                      {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="renovate-contract-pymes-form__space--20"></div>
            <div class="renovate-contract-pymes-form__grid-col--8">
              <div class="renovate-contract-pymes-form__col-span--2 renovate-contract-pymes-form__col-start--7">
                <button class="renovate-contract-pymes-form__button-query" (click)="calculateMarginMatchPrice()"
                  [disabled]="!renovateForm?.get('calculateMargins').valid">
                  {{ 'NEW_CONTRACTS.CALCULATE' | i18nextEager }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container  *ngIf="renovateForm.get('marginIndicator').value === '2' && showCalculation">
          <div class="renovate-contract-pymes-form__section">
            <div class="renovate-contract-pymes-form__header--result renovate-contract-pymes-form__header">
              <h2>{{ 'NEW_CONTRACTS.RESULT_SIMULATION' | i18nextEager }}</h2>
              <div *ngIf="!resultCalculation" class="renovate-contract-pymes-form__header--info">
                {{ 'NEW_CONTRACTS.NO_RESULT' | i18nextEager }}
              </div>
            </div>
            <div *ngIf="resultCalculation"
              class="renovate-contract-pymes-form__select-calculate-commission__result renovate-contract-pymes-form__result">
              <table>
                <tr>
                  <th id="price"></th>
                  <th id="p1">P1</th>
                  <th id="p2">P2</th>
                  <th id="p3">P3</th>
                  <th id="p4">{{ renovateForm.get('fee').value !==
                    '2.0TD' ? 'P4' : '' }}</th>
                  <th id="p5">{{ renovateForm.get('fee').value !==
                    '2.0TD' ? 'P5' : '' }}</th>
                  <th id="p6">{{ renovateForm.get('fee').value !==
                    '2.0TD' ? 'P6' : '' }}</th>
                </tr>
                <tr *ngIf="resultTP.length > 0 && isUserSpanish">
                  <td>
                    TP<span class="units">{{ 'COMMONS.EUROS_KW_YEAR' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let tp of resultTP; let i = index">
                    {{ (renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null : tp) | number: '1.6-6' }}
                  </td>
                </tr>
                <tr *ngIf="resultTE.length > 0 && fixPrice && !passThrough && !fijoFlex">
                  <td>
                    TE<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let te of resultTE; let i = index">
                    {{ (renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null : te) | number: '1.6-6' }}
                  </td>
                </tr>
                <tr *ngIf="resultAI.length > 0 && !fixPrice && !passThrough && !fijoFlex">
                  <td>
                    Ai<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let ai of resultAI; let i = index">
                    {{
                    (renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null : ai ? ai + campaignRealTE[i] : ai)
                    | number: '1.6-6'
                    }}
                  </td>
                </tr>
                <tr *ngIf="fijoFlex  && !isUserSpanish && fijoFlexSimple">
                  <td>
                    <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.PF_REF' | i18nextEager }}</span>
                    <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let pref of campaignPRef; let i = index">
                    {{ renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null
                      : (((isUserSpanish ? renovateForm?.get('enterMargins.marginsTE')?.value 
                      : ((pref/1000) + renovateForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
                    }}                
                  </td>
                </tr>
                <tr *ngIf="campaignKI.length > 0 && !fixPrice && !passThrough || (fijoFlex && !isUserSpanish && fijoFlexSimple)">
                  <td>
                    Ki
                  </td>
                  <td *ngFor="let ki of campaignKI; let i = index">
                    {{ (renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null : ki) | number: '1.3-6' }}
                  </td>
                </tr>
                <tr *ngIf="passThrough && isUserSpanish">
                  <td>
                    <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.GDOS' | i18nextEager }}</span>
                    <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let gdo of campaignGDOS; let i = index">
                    {{ renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null : ((gdo / 1000) | number: '1.6-6') }}
                  </td>
                </tr>
                <tr *ngIf="passThrough || (fijoFlex && !isUserSpanish && fijoFlexSimple)">
                  <td>
                    <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.CG' | i18nextEager }}</span>
                    <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let cg of campaignCG; let i = index">
                    {{
                      renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null
                      : (((isUserSpanish ? renovateForm?.get('enterMargins.marginsTE')?.value 
                      : (cg + renovateForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
                    }}
                  </td>
                </tr>
                <tr *ngIf="passThrough && isUserSpanish">
                  <td>
                    <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FI' | i18nextEager }}</span>
                    <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let fi of campaignFI; let i = index">
                    {{ renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null : ((fi / 1000) | number: '1.6-6') }}
                  </td>
                </tr>
                <tr *ngIf="fijoFlex && !fijoFlexSimple">
                  <td>
                    <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FIXED_PRICE' | i18nextEager }}</span>
                    <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let pfijo of campaignPFijo; let i = index">
                    {{ renovateForm.get('fee').value === '2.0TD' && i >= 3 ? null
                      : (((isUserSpanish ? renovateForm?.get('enterMargins.marginsTE')?.value 
                      : ((pfijo/1000) + renovateForm?.get('enterMargins.marginsTE')?.value)) / 1000) | number: '1.6-6')
                    }}
                  </td>
                </tr>
                <tr *ngIf="fijoFlex && isUserSpanish">
                  <td>
                    <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.S_ADJUST' | i18nextEager }}</span>
                    <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
                  </td>
                  <td *ngFor="let pfijo of campaignPFijo; let i = index">
                    {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager }}
                  </td>
                </tr>
              </table>
              <!-- Hide result of commission -->
              <!-- <ng-container *ngIf="renovateForm.get('marginIndicator').value === '1'">
                <div *ngIf="canSettlements" class="renovate-contract-pymes-form__grid-col--7">
                  <div class="renovate-contract-pymes-form__title-terms">
                    <div class="renovate-contract-pymes-form__title-terms--bold">
                      {{ 'NEW_CONTRACTS.COMMISSION' | i18nextEager }}
                    </div>
                    <div>
                      <span class="renovate-contract-pymes-form__title-terms--bold">€</span>
                    </div>
                  </div>
                  <div class="renovate-contract-pymes-form__row-values--border-red">
                    <div class="renovate-contract-pymes-form__row-values--col-value">
                      <div class="renovate-contract-pymes-form__row-values--center">
                        <div class="renovate-contract-pymes-form__row-values--value">
                          {{ commission | number: '1.0-2' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="renovateForm.get('marginIndicator').value === '2'">
                <div formGroupName="enterMargins">
                  <div class="renovate-contract-pymes-form__grid-col--7">
                    <div class="renovate-contract-pymes-form__title-terms">
                      <div class="renovate-contract-pymes-form__title-terms--bold">
                        {{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }}
                      </div>
                      <div>
                        <span class="renovate-contract-pymes-form__title-terms--bold">{{
                          'NEW_CONTRACTS.EURO' | i18nextEager
                        }}</span>
                        <span class="renovate-contract-pymes-form__title-terms--normal">{{
                          'NEW_CONTRACTS.MW_HOUR_2' | i18nextEager
                        }}</span>
                      </div>
                    </div>
                    <div class="renovate-contract-pymes-form__row-values--border-red">
                      <div class="renovate-contract-pymes-form__row-values--col-value">
                        <div class="renovate-contract-pymes-form__row-values--center">
                          <div class="renovate-contract-pymes-form__row-values--value">
                            {{ renovateForm.get('enterMargins.marginsTE').value | number: '1.0-2' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="renovate-contract-pymes-form__title-terms--right">
                      <div class="renovate-contract-pymes-form__title-terms--bold">
                        {{ 'NEW_CONTRACTS.MARGIN_TP' | i18nextEager }}
                      </div>
                      <div>
                        <span class="renovate-contract-pymes-form__title-terms--bold">{{
                          'NEW_CONTRACTS.EURO' | i18nextEager
                        }}</span>
                        <span class="renovate-contract-pymes-form__title-terms--normal">{{
                          'NEW_CONTRACTS.KW_ANY' | i18nextEager
                        }}</span>
                      </div>
                    </div>
                    <div class="renovate-contract-pymes-form__row-values--border-red">
                      <div class="renovate-contract-pymes-form__row-values--col-value">
                        <div class="renovate-contract-pymes-form__row-values--center">
                          <div class="renovate-contract-pymes-form__row-values--value">
                            {{ renovateForm.get('enterMargins.marginTP').value | number: '1.0-2' }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="canSettlements">
                      <div class="renovate-contract-pymes-form__title-terms--right">
                        <div class="renovate-contract-pymes-form__title-terms--bold">
                          {{ 'NEW_CONTRACTS.COMMISSION' | i18nextEager }}
                        </div>
                        <div>
                          <span class="renovate-contract-pymes-form__title-terms--bold">
                            {{ 'NEW_CONTRACTS.EURO' | i18nextEager }}
                          </span>
                        </div>
                      </div>
                      <div class="renovate-contract-pymes-form__row-values--border-red">
                        <div class="renovate-contract-pymes-form__row-values--col-value">
                          <div class="renovate-contract-pymes-form__row-values--center">
                            <div class="renovate-contract-pymes-form__row-values--value">
                              {{ commission | number: '1.0-2' }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container> -->
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!renovateForm.get('campaignBase').value" class="renovate-contract-pymes-form__container">
        <app-custom-select class="width100" [label]="'RENOVATE_COTRACT.LEVEL'" [required]="true" [controlName]="'level'"
          [values]="levelList" [defaultValue]="renovateForm.get('level').value"
          [disabled]="renovateForm.get('level').disabled"></app-custom-select>
      </div>
    </form>
  </section>
  <section>
    <h2 class="renovate-contract-pymes-form__title">
      {{ 'RENOVATE_COTRACT.NOTIFICATION_ADDRESS' | i18nextEager | uppercase }}
    </h2>
    <form [formGroup]="renovateForm" class="renovate-contract-pymes-form__container">
      <div>
        <app-custom-select [label]="'RENOVATE_COTRACT.VIA_TYPE'" [controlName]="'viaType'" [values]="viaTypesList"
          [defaultValue]="renovateForm.get('viaType').value" [required]="true" [searchBar]="true"
          [disabled]="renovateForm.get('viaType').disabled"></app-custom-select>
        <mat-error *ngIf="
            renovateForm.get('viaType').errors?.required &&
            (renovateForm.get('viaType').touched || renovateForm.get('viaType').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.ROAD_NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="roadName" maxlength="100" />
        <mat-error *ngIf="
            renovateForm.get('roadName').errors?.required &&
            (renovateForm.get('roadName').touched || renovateForm.get('roadName').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="tree-col" *ngIf="isUserSpanish">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
            <input matInput formControlName="number" maxlength="8" alphanumeric />
            <mat-error *ngIf="
                renovateForm.get('number').errors?.maxlength &&
                (renovateForm.get('number').touched || renovateForm.get('number').dirty)
              ">
              {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                !renovateForm.get('number').errors?.maxlength &&
                renovateForm.get('number').errors?.invalidInitialValue &&
                (renovateForm.get('number').touched || renovateForm.get('number').dirty)
              ">
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.ADDRESS_GATE' | i18nextEager }}</mat-label>
            <input matInput formControlName="gate" maxlength="10" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.ADDRESS_STAIR' | i18nextEager }}</mat-label>
            <input matInput formControlName="stair" maxlength="3" alphanumeric />
            <mat-error *ngIf="
                renovateForm.get('stair').errors?.maxlength &&
                (renovateForm.get('stair').touched || renovateForm.get('stair').dirty)
              ">
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                !renovateForm.get('stair').errors?.maxlength &&
                renovateForm.get('stair').errors?.invalidInitialValue &&
                (renovateForm.get('stair').touched || renovateForm.get('stair').dirty)
              ">
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="tree-col">
        <div class="col" *ngIf="isUserSpanish">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
            <input matInput formControlName="floor" maxlength="3" alphanumeric />
            <mat-error *ngIf="
                renovateForm.get('floor').errors?.maxlength &&
                (renovateForm.get('floor').touched || renovateForm.get('floor').dirty)
              ">
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                !renovateForm.get('floor').errors?.maxlength &&
                renovateForm.get('floor').errors?.invalidInitialValue &&
                (renovateForm.get('floor').touched || renovateForm.get('floor').dirty)
              ">
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="isUserSpanish">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.ADDRESS_DOOR' | i18nextEager }}</mat-label>
            <input matInput formControlName="door" maxlength="3" alphanumeric />
            <mat-error *ngIf="
                renovateForm.get('door').errors?.maxlength &&
                (renovateForm.get('door').touched || renovateForm.get('door').dirty)
              ">
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                !renovateForm.get('door').errors?.maxlength &&
                renovateForm.get('door').errors?.invalidInitialValue &&
                (renovateForm.get('door').touched || renovateForm.get('door').dirty)
              ">
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field *ngIf="isUserSpanish" appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.POSTAL_CODE' | i18nextEager }}</mat-label>
            <input matInput formControlName="postalCode" numeric maxlength="5" />
            <mat-error *ngIf="
                renovateForm.get('postalCode').errors?.required &&
                (renovateForm.get('postalCode').touched || renovateForm.get('postalCode').dirty)
              ">
              {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <div *ngIf="!isUserSpanish">
            <div class="renovate-contract-pymes-form__pt-postal-code-field">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                <input matInput formControlName="postalCodePT1" maxlength="4" />
              </mat-form-field>
              <p class="renovate-contract-pymes-form__postal-code-hyphen">
                {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
              </p>
              <mat-form-field appearance="outline">
                <input matInput formControlName="postalCodePT2" maxlength="3" />
              </mat-form-field>
            </div>
            <mat-error
              *ngIf="
                (
                  renovateForm?.controls.postalCodePT1.errors?.required ||
                  renovateForm?.controls.postalCodePT2.errors?.required
                ) &&
                (
                  renovateForm.controls.postalCodePT1.touched ||
                  renovateForm.controls.postalCodePT1.dirty ||
                  renovateForm.controls.postalCodePT2.touched ||
                  renovateForm.controls.postalCodePT2.dirty
                )
              "
              class="renovate-contract-pymes-form__pt-postal-code-error"
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !renovateForm?.controls.postalCodePT1.errors?.required &&
                !renovateForm?.controls.postalCodePT2.errors?.required &&
                renovateForm?.controls.postalCode.errors?.pattern &&
                (
                  renovateForm.controls.postalCodePT1.touched ||
                  renovateForm.controls.postalCodePT1.dirty ||
                  renovateForm.controls.postalCodePT2.touched ||
                  renovateForm.controls.postalCodePT2.dirty
                )
              "
              class="renovate-contract-pymes-form__pt-postal-code-error"
            >
              {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
            </mat-error>
          </div>
        </div>
      </div>
      <mat-form-field appearance="outline" *ngIf="townList?.length <= 1">
        <mat-label>{{ 'RENOVATE_COTRACT.TOWN' | i18nextEager }}</mat-label>
        <input matInput formControlName="town" maxlength="100" />
        <mat-error *ngIf="
            renovateForm.get('town').errors?.required &&
            (renovateForm.get('town').touched || renovateForm.get('town').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <app-custom-select *ngIf="townList?.length > 1" [label]="'RENOVATE_COTRACT.TOWN'" [controlName]="'town'"
        [required]="true" [values]="townList" [defaultValue]="renovateForm.get('town').value"
        [disabled]="renovateForm.get('town').disabled">
        <mat-error *ngIf="
            renovateForm.get('town').errors?.required &&
            (renovateForm.get('town').touched || renovateForm.get('town').dirty)
          ">
          {{ 'COMMONS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </app-custom-select>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.PROVINCE' | i18nextEager }}</mat-label>
        <input matInput formControlName="province" maxlength="100"
          placeholder="{{ 'RENOVATE_COTRACT.PROVINCE_PLACEHOLDER' | i18nextEager }}" />
        <mat-error *ngIf="
            renovateForm.get('province').errors?.required &&
            (renovateForm.get('province').touched || renovateForm.get('province').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </section>
  <section>
    <h2 class="renovate-contract-pymes-form__title">
      {{ 'RENOVATE_COTRACT.CONTACT' | i18nextEager | uppercase }}
    </h2>
    <form [formGroup]="renovateForm" class="renovate-contract-pymes-form__container">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="name" maxlength="50" />
        <mat-error *ngIf="
            renovateForm.get('name').errors?.required &&
            (renovateForm.get('name').touched || renovateForm.get('name').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.SURNAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="surname" maxlength="50" />
        <mat-error *ngIf="
            renovateForm.get('surname').errors?.required &&
            (renovateForm.get('surname').touched || renovateForm.get('surname').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.DNI' | i18nextEager }}</mat-label>
        <input matInput formControlName="dni" maxlength="9" placeholder="Ej. 00000000A" />
        <mat-error *ngIf="
            renovateForm.get('dni').errors?.required &&
            (renovateForm.get('dni').touched || renovateForm.get('dni').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="
            renovateForm.get('dni').errors?.invalid_dni &&
            (renovateForm.get('dni').touched || renovateForm.get('dni').dirty)
          ">
          {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.EMAIL' | i18nextEager }}</mat-label>
        <input matInput formControlName="email" placeholder="samplemail@mail.com" maxlength="50" />
        <mat-error *ngIf="
            renovateForm.get('email').errors?.required &&
            (renovateForm.get('email').touched || renovateForm.get('email').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="
            renovateForm.get('email').errors &&
            renovateForm.get('email').value &&
            (renovateForm.get('email').touched || renovateForm.get('email').dirty)
          ">
          {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="renovate-contract-pymes-form__mobile-field">
        <div *ngIf="!isUserSpanish" class="renovate-contract-pymes-form__country-code">
          <app-custom-select
            [required]="true"
            [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
            [controlName]="'phoneCountryCode'"
            [values]="mobileCountryCodeList"
            [disabled]="renovateForm.get('phoneCountryCode').disabled"
            [defaultValue]="renovateForm.get('phoneCountryCode').value"
          ></app-custom-select>
        </div>
        <div class="renovate-contract-pymes-form__mobile-input">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.PHONE' | i18nextEager }}</mat-label>
            <input matInput formControlName="phone" maxlength="9" />
            <mat-error *ngIf="
                renovateForm.get('phone').errors?.required &&
                (renovateForm.get('phone').touched || renovateForm.get('phone').dirty)
              ">
              {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                renovateForm.get('phone').errors?.invalid_mobile &&
                (renovateForm.get('phone').touched || renovateForm.get('phone').dirty)
              ">
              {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>
  <section>
    <h2 class="renovate-contract-pymes-form__title">
      {{ 'RENOVATE_COTRACT.DATA_SIGNED' | i18nextEager | uppercase }}
    </h2>
    <form [formGroup]="renovateForm" class="renovate-contract-pymes-form__container">
      <mat-checkbox (change)="copyContactToSigner($event)" [disabled]="!this.approved">
        {{ 'RENOVATE_COTRACT.AUTOFILL' | i18nextEager }}
      </mat-checkbox>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="nameSigner" maxlength="50" />
        <mat-error *ngIf="
            renovateForm.get('nameSigner').errors?.required &&
            (renovateForm.get('nameSigner').touched || renovateForm.get('nameSigner').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.SURNAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="surnameSigner" maxlength="50" />
        <mat-error *ngIf="
            renovateForm.get('surnameSigner').errors?.required &&
            (renovateForm.get('surnameSigner').touched || renovateForm.get('surnameSigner').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.DNI' | i18nextEager }}</mat-label>
        <input matInput formControlName="dniSigner" maxlength="9" placeholder="Ej. 00000000A" />
        <mat-error *ngIf="
            renovateForm.get('dniSigner').errors?.required &&
            (renovateForm.get('dniSigner').touched || renovateForm.get('dniSigner').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="
            renovateForm.get('dniSigner').errors?.invalid_dni &&
            (renovateForm.get('dniSigner').touched || renovateForm.get('dniSigner').dirty)
          ">
          {{ 'NEW_CONTRACTS.DNI_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'RENOVATE_COTRACT.EMAIL' | i18nextEager }}</mat-label>
        <input matInput formControlName="emailSigner" placeholder="samplemail@mail.com" maxlength="50" />
        <mat-error *ngIf="
            renovateForm.get('emailSigner').errors?.required &&
            (renovateForm.get('emailSigner').touched || renovateForm.get('emailSigner').dirty)
          ">
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="
            renovateForm.get('emailSigner').errors &&
            renovateForm.get('emailSigner').value &&
            (renovateForm.get('emailSigner').touched || renovateForm.get('emailSigner').dirty)
          ">
          {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="renovate-contract-pymes-form__mobile-field">
        <div *ngIf="!isUserSpanish" class="renovate-contract-pymes-form__country-code">
          <app-custom-select
            [required]="true"
            [label]="'NEW_CONTRACTS.MOBILE_COUNTRY_CODE.LABEL'"
            [controlName]="'phoneSignerCountryCode'"
            [values]="mobileCountryCodeList"
            [disabled]="renovateForm.get('phoneSignerCountryCode').disabled"
            [defaultValue]="renovateForm.get('phoneSignerCountryCode').value"
          ></app-custom-select>
        </div>
        <div class="renovate-contract-pymes-form__mobile-input">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'RENOVATE_COTRACT.PHONE' | i18nextEager }}</mat-label>
            <input matInput formControlName="phoneSigner" maxlength="9" />
            <mat-error *ngIf="
                renovateForm.get('phoneSigner').errors?.required &&
                (renovateForm.get('phoneSigner').touched || renovateForm.get('phoneSigner').dirty)
              ">
              {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
            </mat-error>
            <mat-error *ngIf="
                renovateForm.get('phoneSigner').errors?.invalid_mobile &&
                (renovateForm.get('phoneSigner').touched || renovateForm.get('phoneSigner').dirty)
              ">
              {{ 'NEW_CONTRACTS.MOBILE_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>
  <section *ngIf="isUserSpanish">
    <h2 class="renovate-contract-pymes-form__title">
      {{ 'RENOVATE_COTRACT.ACCOUNT_BANK' | i18nextEager | uppercase }}
    </h2>
    <form [formGroup]="renovateForm" class="renovate-contract-pymes-form__container">
      <div *ngIf="dataContract.contract.renovateAccount && isUserSpanish"
        class="renovate-contract-pymes-form__hide-account renovate-contract-pymes-form__account--margin-bottom">
        <div id="iban">****</div>
        <div id="entity">****</div>
        <div id="office">****</div>
        <div id="dc">**</div>
        <div id="account">******{{ dataContract.contract.renovateAccount?.slice(-4) }}</div>
      </div>
      <div class="renovate-contract-pymes-form__account">
        <mat-form-field appearance="outline" id="iban">
          <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
          <input matInput uppercase id="ibanInput" formControlName="iban" maxlength="4" (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, null, 'ibanInput', 'entityInput')" />
        </mat-form-field>
        <mat-form-field appearance="outline" id="entity">
          <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
          <input matInput numeric id="entityInput" formControlName="entity" maxlength="4" (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'ibanInput', 'entityInput', 'officeInput')" />
        </mat-form-field>
        <mat-form-field appearance="outline" id="office">
          <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
          <input matInput numeric id="officeInput" formControlName="office" maxlength="4" (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'entityInput', 'officeInput', isUserSpanish ? 'dcInput' : 'accountInput')" />
        </mat-form-field>
        <mat-form-field *ngIf="isUserSpanish" appearance="outline" id="dc">
          <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
          <input matInput numeric id="dcInput" formControlName="dc" maxlength="2" (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'officeInput', 'dcInput', 'accountInput')" />
        </mat-form-field>
        <mat-form-field appearance="outline" id="account">
          <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
          <input matInput numeric id="accountInput" formControlName="account" [maxlength]="isUserSpanish ? 10 : 11" (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, isUserSpanish ? 'dcInput' : 'officeInput', 'accountInput', isUserSpanish ? null : 'dcInput')" />
        </mat-form-field>
        <mat-form-field *ngIf="!isUserSpanish" appearance="outline" id="dc">
          <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
          <input matInput numeric id="dcInput" formControlName="dc" maxlength="2" (paste)="onPasteIBAN($event)"
            (keyup)="bankAccountKeyUp($event, 'accountInput', 'dcInput', null)"
          />
        </mat-form-field>
      </div>
      <div class="renovate-contract-pymes-form__account-error" *ngIf="renovateForm?.hasError('invalid_IBAN')">
        <mat-error>
          {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
        </mat-error>
      </div>
    </form>
  </section>
</div>